import type { OpenXAgentMessage } from '@openx/components-core/lib/AiChat/types';
import { useCallback, useMemo, useState } from 'react';
import {
  getActiveRichContentKeys,
  type RichContentActionEvent,
  type RichContentConfig,
} from '../../RichComponents/utils/richContent';

export const useRichContentConfig = (
  messages: OpenXAgentMessage[],
  onRichContentAction?: (event: RichContentActionEvent) => void
): RichContentConfig => {
  const [confirmedActionKeys, setConfirmedActionKeys] = useState<ReadonlySet<string>>(() => new Set());
  const activeKeys = useMemo(() => getActiveRichContentKeys(messages), [messages]);

  const onAction = useCallback(
    (event: RichContentActionEvent) => {
      if (!activeKeys.has(event.contentKey)) return;

      setConfirmedActionKeys(previous => new Set(previous).add(event.actionKey));
      onRichContentAction?.(event);
    },
    [activeKeys, onRichContentAction]
  );

  return useMemo(() => ({ activeKeys, confirmedActionKeys, onAction }), [activeKeys, confirmedActionKeys, onAction]);
};
